import { bootstrapApplication } from '@angular/platform-browser';
//import { appConfig } from './app.config';
//import { App } from '././app';
import { AppRootComponent } from './app/app-root/app-root.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppRootComponent, appConfig)
  .catch((err) => console.error(err));
